import React from 'react';

const NewUserList_Admin = ({ users = [] }) => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return (
    <div className="border-[2px] border-black p-2 text-lg w-full">
      <p className="p-2">
        [New Users added since {yesterday.toDateString()}]
      </p>

      <p className="p-2">
        Users added in last 24hrs : {users.length}
      </p>

      {users.length === 0 && (
        <p className="p-2 text-gray-500">No new users</p>
      )}

      {users.map((item, idx) => (
        <div
          key={item._id}
          className="border-t border-black hover:bg-slate-100 cursor-pointer"
        >
          <div className="reviewers">
            <span className="w-8">#{idx + 1}</span>

            <img
              className="w-16 h-16 rounded-full border border-black"
              src={item.profilePicUrl || '/user.png'}
              alt={`${item.firstname} profile`}
            />

            <div className="text-left">
              <b>
                {item.firstname} {item.lastname}
              </b>

              <p className="text-gray-600">
                Phone : {item.whatsappnumber || 'N/A'}
              </p>
              <p className="text-gray-600">
                Email : {item.email || 'N/A'}
              </p>
            </div>

            <button className="View_profile">
              View Profile
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NewUserList_Admin;
